var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWawiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3542 0H16.0685C15.5951 0.00151237 15.1417 0.190618 14.8075 0.525876C14.4733 0.861135 14.2856 1.3152 14.2856 1.78857V48.2171C14.2856 48.69 14.4735 49.1435 14.8078 49.4778C15.1422 49.8122 15.5957 50 16.0685 50H55.3542C55.8276 50 56.2817 49.8124 56.6169 49.4782C56.9522 49.144 57.1413 48.6905 57.1428 48.2171V1.78857C57.1428 1.31421 56.9544 0.859283 56.6189 0.52386C56.2835 0.188438 55.8286 0 55.3542 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1428 12.5028H14.2856V25H57.1428V12.5028Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1428 12.5029V1.78857C57.1428 1.31421 56.9544 0.859282 56.6189 0.52386C56.2835 0.188438 55.8286 0 55.3542 0H16.0685C15.5951 0.00151236 15.1417 0.190618 14.8075 0.525876C14.4733 0.861135 14.2856 1.3152 14.2856 1.78857V12.5029H57.1428Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2856 37.4971V48.2171C14.2856 48.6899 14.4735 49.1434 14.8078 49.4778C15.1422 49.8121 15.5957 50 16.0685 50H55.3542C55.8276 50 56.2817 49.8123 56.6169 49.4781C56.9522 49.1439 57.1413 48.6905 57.1428 48.2171V37.4971H14.2856Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1428 25H14.2856V37.4971H57.1428V25Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 24.9999C28.5714 17.1101 22.1755 10.7142 14.2857 10.7142C6.39593 10.7142 0 17.1101 0 24.9999C0 32.8897 6.39593 39.2856 14.2857 39.2856C22.1755 39.2856 28.5714 32.8897 28.5714 24.9999Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7884 19.9999L19.9027 31.8914H16.9427L14.3256 23.8114L11.6284 31.8628H8.68557L4.78271 19.9999H7.63986L10.3256 28.3599L13.1427 19.9999H15.6913L18.3884 28.3999L21.1427 19.9999H23.7884Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.2856,
    y1: 25,
    x2: 57.1428,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C60008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.2856,
    y1: 18.7485,
    x2: 57.1428,
    y2: 18.7485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD2724"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.2856,
    y1: 6.24857,
    x2: 57.1428,
    y2: 6.24857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C60008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 14.2856,
    y1: 43.7457,
    x2: 57.1428,
    y2: 43.7457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD2724"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14.2856,
    y1: 31.2457,
    x2: 57.1428,
    y2: 31.2457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C60008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 0,
    y1: 24.9934,
    x2: 28.5714,
    y2: 24.9934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C60008"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWawiLogo);
export default __webpack_public_path__ + "static/media/wawi-logo.b5bb420296fbe664c4b27fe1873c7d9c.svg";
export { ForwardRef as ReactComponent };